import React from 'react';
import styled from '@emotion/styled';
import OtherBankPaymentTypeRadio from '../radio/OtherBankPaymentTypeRadio';
import OtherBankPaymentType from '../select/OtherBankPaymentType';
import OtherBankPaymentContents from '../payment/OtherBankPaymentContents';

const Base = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: auto auto 1fr;

    input:last-of-type {
      justify-self: end;
    }
  }
`;

/**
 *  타금융사 할부조건 가용금액 컨텐츠 컴포넌트
 *  */
function OtherBankPaymentTypeContents(): JSX.Element {
  return (
    <Base>
      <OtherBankPaymentTypeRadio />
      <OtherBankPaymentType />
      <OtherBankPaymentContents />
    </Base>
  );
}

export default OtherBankPaymentTypeContents;
